import { Individual } from '@aslanpay/portal-common-lib';

const individualFullName = (individual: Individual) => {
  return `${individual.firstName} ${individual.lastName}`;
};

export default { individualFullName };
